export default __webpack_public_path__ + "static/media/javascript.8cb47c0f.jpg";